<template>
  <v-row no-gutters justify="center" align="center">
    <v-col class="left-part pr-10" v-if="!isMobile">
      <div class="pt-5 pb-10">
        <a href="https://www.indeego.fr" class="back-btn">
          <v-icon>chevron_left</v-icon>
          <span>Retour sur le site</span>
        </a>
      </div>
      <div class="text-h2 font-weight-bold">
        S'inscrire sur
        <br>
        Indeego
      </div>
      <div class="text-subtitle-1 pt-6">
        Si vous avez déjà un compte, <a href="https://www.indeego.fr/login" class="login-btn">connectez-vous</a>
      </div>
      <v-row no-gutters justify="end" align="end" class="mt-auto pt-6">
        <img
          src="@/assets/img/worker0.png"
          alt="Indeego worker"
          class="illustration"
        >
      </v-row>
      <div class="bg-image" />
    </v-col>
    <div
      class="signup-wrapper d-flex align-self-stretch align-start justify-center"
    >
      <signup />
    </div>
  </v-row>
</template>

<script>
import Signup from '@/components/Signup.vue';

export default {
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width <= 910;
    },
  },

  beforeMount() {
    window.document.title = `S'inscrire sur Indeego`;
  },

  components: {
    Signup,
  },
};
</script>

<style lang="scss">
.back-btn {
  opacity: .7;
  &, &:hover span {
    text-decoration: none !important;
  }
  span {
    text-decoration: underline !important;
  }
  // .v-icon {
  // }
}
.left-part {
  min-height: 600px;
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: transparent;
  z-index: 10;
  * {
    position: relative;
  }
  .bg-image {
    z-index: 0;
    position: absolute;
    left: -60px;
    top: -60px;
    height: 300px;
    width: 300px;
    background-image: url('~@/assets/img/logo_square.png');
    background-size: 400px;
    pointer-events: none;
    // background-position: -40px -40px;
    filter: blur(90px);
    -webkit-filter: blur(90px);
    opacity: 0.25;
    box-shadow: inset 0 0 0 2000px rgb(255, 213, 60);
    // opacity: 0.35;
    // box-shadow: inset 0 0 0 2000px rgb(60 174 255 / 50%);
  }
}
.login-btn {
  color: $primaryColor;
  font-weight: 500;
  &:hover {
    text-decoration: none !important;
  }
}
.illustration {
  width: 400px;
  max-width: 80%;
  // height: 400px;
  // max-height: 450px;
}
.signup-wrapper {
  max-width: 90%;
  width: 420px;
  // background-color: #F6F6F6;
  // background-color: #F6F6F6;
  border-radius: 10px;
}
</style>
